import { useEffect } from 'react'

interface Props {
  key: string
  onChange: (cookie?: string) => any
}

const useCookieChange = ({ key, onChange }: Props) => {
  useEffect(() => {
    let previousValue = getCookieValue(key)

    const checkCookie = () => {
      const currentValue = getCookieValue(key)

      if (previousValue !== currentValue) {
        onChange(currentValue)
      }

      previousValue = currentValue
    }

    const interval = setInterval(checkCookie, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])
}

function getCookieValue(key: string) {
  if (!document.cookie) return undefined

  const plainCookies = document.cookie.split(';')

  return plainCookies
    .map(plainCookie => {
      const [cookieKey, cookieValue] = plainCookie.trim().split('=')
      return {
        cookieKey,
        cookieValue,
      }
    })
    .find(({ cookieKey }) => cookieKey === key)?.cookieValue
}

export default useCookieChange
